import '../app.es6';
import angular from 'angular';

function createSwingTypeConstants () {
  let t = [{
    id: 0,
    orderId: 0,
    label: 'フォアハンド スピン/フラット',
    color: '#ff6d1f'
  }, {
    id: 1,
    orderId: 1,
    label: 'フォアハンド スライス',
    color: '#cb2020'
  }, {
    id: 2,
    orderId: 4,
    label: 'フォアハンド ボレー',
    color: '#517fb7'
  }, {
    id: 3,
    orderId: 2,
    label: 'バックハンド スピン/フラット',
    color: '#800000'
  /* }, {
    // id:4 は id:3 のBackhand spin/flatと同じものを指す模様なので、
    // SwingTypeとしてはid:4は欠番、Arrayの添字は繰り上げる
    // Backhand Spin/FlatDのDはDouble Handを表す
    id: 4,
    label: 'Backhand Spin/FlatD',
    color: '#793766'
  */
  }, {
    id: 5,
    orderId: 3,
    label: 'バックハンド スライス',
    color: '#793766'
  }, {
    id: 6,
    orderId: 6,
    label: 'バックハンド ボレー',
    color: '#12a1cb'
  }, {
    id: 7,
    orderId: 7,
    label: 'スマッシュ',
    color: '#288666'
  }, {
    id: 8,
    orderId: 8,
    label: 'サーブ',
    color: '#90aa40'
  }];

  t._swingTypeRevMap = {};
  t.forEach((st) => {
    t._swingTypeRevMap[st.label] = st;
  });

  t.get = function (id, def = null) {
    return t[id] || def;
  };
  t.getLabel = function (id, def = id) {
    // workaround for duplicated type id:3
    if (id > 3) id--;
    let o = t[id];
    if (!o) {
      return def;
    }
    return o.label;
  };
  t.getByLabel = function (label, def = null) {
    return t._swingTypeRevMap[label] || def;
  };
  t.getOrderIdByLabel = function (label, def = label) {
    let o = t.getByLabel(label);
    if (!o) {
      return def;
    }
    return o.orderId;
  };
  t.getColorByLabel = function (label, def = null) {
    let o = t.getByLabel(label);
    if (!o) {
      return def;
    }
    return o.color;
  };

  return t;
}

angular.module('myApp').factory('SwingTypeConstants', createSwingTypeConstants);



// WEBPACK FOOTER //
// ./app/services/swing-type-constants.es6